import React, { Component } from 'react';
import { View, Animated, Dimensions } from 'react-native';
import Carousel from 'react-native-reanimated-carousel';

import { ViewPropTypes } from 'deprecated-react-native-prop-types';
import { isFunction as _isFunction, get as _get } from 'lodash';
import PropTypes from 'prop-types';

import FoundationTestKeys from '../../FoundationTestKeys';

import styles from './CardCarousel.Styles';

const { width: screeWidth } = Dimensions.get('window');

const SWIPE_OUT_DURATION = 500;

const SwipeDirections = Object.freeze({
  RIGHT: 'right',
  LEFT: 'left',
});

class CardCarousel extends Component {
  constructor(props) {
    super(props);

    this.swipeThreshold = 0.25 * screeWidth;
    this.hasInvokedOnSwipeStart = false;
    this.currentSwipeDirection = undefined;

    this.activeCardPositionAnimation = new Animated.ValueXY(0);

    if (_isFunction(props.onCardPositionChange)) {
      this.activeCardPositionAnimation.addListener(newPositionObj =>
        props.onCardPositionChange(newPositionObj),
      );
    }

    this.state = {
      activeCardIndex: props.initialActiveCard,
    };
  }

  componentDidUpdate(prevProps) {
    if (
      prevProps.activeCardIndex !== this.props.activeCardIndex &&
      this.props.activeCardIndex !== this.state.activeCardIndex
    ) {
      this.scrollTo(this.props.activeCardIndex);
    }
  }

  onSwipeComplete = (direction, step = 1) => {
    const { onSwipe } = this.props;
    const { activeCardIndex } = this.state;

    const newActiveCardIndex =
      direction === SwipeDirections.RIGHT ? activeCardIndex - step : activeCardIndex + step;

    this.activeCardPositionAnimation.setValue({ x: 0, y: 0 });
    this.setState({ activeCardIndex: newActiveCardIndex });
    if (_isFunction(onSwipe)) {
      onSwipe(newActiveCardIndex);
    }
  };

  swipe = (direction, step = 1) => {
    if (
      (this.state.activeCardIndex >= step && direction === SwipeDirections.RIGHT) ||
      (_get(this.props, 'data.length', 0) - 1 - step >= this.state.activeCardIndex &&
        direction === SwipeDirections.LEFT)
    ) {
      const { duration } = this.props;
      const x = direction === SwipeDirections.RIGHT ? step * screeWidth : -step * screeWidth;

      Animated.timing(this.activeCardPositionAnimation, {
        toValue: { x, y: 0 },
        duration,
        useNativeDriver: false,
      }).start(
        /* istanbul ignore next */ () => {
          this.onSwipeComplete(direction, step);
        },
      );
    }
  };

  scrollTo = index => {
    const direction =
      index > this.state.activeCardIndex ? SwipeDirections.LEFT : SwipeDirections.RIGHT;
    this.swipe(direction, Math.abs(index - this.state.activeCardIndex));
  };

  renderCardsCarousel = data => {
    const { activeCardIndex } = this.state;
    const { renderCard, style } = this.props;

    return (
      <Carousel
        {...this.props}
        style={[styles.cardContainerStyle, style]}
        loop={false}
        width={screeWidth * 0.93}
        data={data}
        scrollAnimationDuration={300}
        onSnapToItem={index => {
          this.props.onSwipe(index);
        }}
        renderItem={({ item, index }) =>
          renderCard({ item, index, isActiveCard: activeCardIndex === index, data })
        }
        onProgressChange={offsetProgress => {
          this.activeCardPositionAnimation.setValue({ x: offsetProgress, y: 0 });
        }}
        testID={FoundationTestKeys.carousel}
      />
    );
  };

  render() {
    const { data, containerStyle, ...props } = this.props;

    return (
      <View
        {...props}
        style={[styles.containerStyle, containerStyle]}
        testID={FoundationTestKeys.carouselView}
      >
        {this.renderCardsCarousel(data)}
      </View>
    );
  }
}

CardCarousel.defaultProps = {
  data: [],
  renderCard: ({ item, index, isActiveCard, data }) => null,
  duration: SWIPE_OUT_DURATION,
  initialActiveCard: 0,
};

CardCarousel.propTypes = {
  renderCard: PropTypes.func.isRequired,
  data: PropTypes.arrayOf(PropTypes.any).isRequired,
  containerStyle: ViewPropTypes.style,
  style: ViewPropTypes.style,
  onSwipe: PropTypes.func,
  onCardPositionChange: PropTypes.func,
  duration: PropTypes.number,
  initialActiveCard: PropTypes.number,
  activeCardIndex: PropTypes.number,
  isSwipeDisabled: PropTypes.bool,
};

export default CardCarousel;
